import { render, staticRenderFns } from "./CategoriesTree.vue?vue&type=template&id=ae83dbd8"
import script from "./CategoriesTree.vue?vue&type=script&lang=ts"
export * from "./CategoriesTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports